<div class="feature-section bg-lem-bg-default p-3 rounded-3">
    <h2 class="fs-4 mb-4 fw-semibold text-center">Praktische Funktionen im Blätterbuch</h2>
    <div #features id="section-tools" class="feature-list align-items-start d-flex gap-4 justify-content-center">
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'sidebar/sidebar-icon-kapitel.png' | asset" alt="Feature Kapitel, Lesezeichen" />
            <span><strong>Kapitel, Lesezeichen</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/d4s-welcome-icon-tool-notizen.png' | asset" alt="Feature Notizen und Markierungen" />
            <span><strong>Notizen und Markierungen</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/d4s-welcome-icon-tool-zeichnen.png' | asset" alt="Feature Zeichnen und Annotieren" />
            <span><strong>Zeichnen und Annotieren</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'hsm-icon.png' | asset" alt="Feature Lexikon" />
            <span><strong>Lexikon</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'button-mbook-hover-active.png' | asset" alt="Feature mbook" />
            <span><strong>mbook Ansicht</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'button-yedo-hover.png' | asset" alt="Feature Yedo" />
            <span><strong>yedo Ansicht</strong></span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'button-wbook-hover.png' | asset" alt="Feature Webbuch" />
            <span><strong>Webbuch Ansicht</strong></span>
        </div>
    </div>
</div>